import {
  AppWindow, BedDouble, Car, Clapperboard, Fuel, GraduationCap, HeartPulse,
  Landmark, Laptop, Plane, Shirt, ShoppingBag, ShoppingCart, Smartphone,
  Sofa, UtensilsCrossed, Wrench,
} from "lucide-react";
import { mccCategory } from "./mccCategories";

// Значок категории операции. Один глиф на категорию, без своего цвета:
// цвет здесь ничего не сообщал бы, а логотипам брендов рядом мешал бы
// выделяться. Смысл несёт форма.
const ICONS = {
  grocery: ShoppingCart,
  dining: UtensilsCrossed,
  transport: Car,
  travel: Plane,
  hotel: BedDouble,
  fuel: Fuel,
  telecom: Smartphone,
  software: AppWindow,
  entertainment: Clapperboard,
  health: HeartPulse,
  education: GraduationCap,
  electronics: Laptop,
  apparel: Shirt,
  home: Sofa,
  finance: Landmark,
  government: Landmark,
  services: Wrench,
  retail: ShoppingBag,
};

export const categoryIconFor = (mcc) => ICONS[mccCategory(mcc)] || null;

const CategoryIcon = ({ mcc, className = "h-4 w-4" }) => {
  const Icon = categoryIconFor(mcc);
  if (!Icon) return null;
  return <Icon className={className} aria-hidden="true" />;
};

export default CategoryIcon;
